import * as tslib_1 from "tslib";
import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import * as utils from '@ivy/fts/utils';
let DiscountSale = class DiscountSale extends Vue {
    constructor() {
        super(...arguments);
        this.timeText = '距结束还剩:';
        this.timer = null;
        this.canShow = false;
        this.activeItem = '';
        // discountData: any = {}
        this.limitTime = [];
        this.typeMap = {
            presell: '定金预售',
            limit_buy: '限时折扣',
            group: '限时拼团',
            limit_free: '限时免费',
            will_sale: '即将开售',
            will_out: '即将停售',
            is_out: '已下架',
        };
        this.activeList = {
            presell: '定金预售',
            group: '限时拼团',
            limit_buy: '限时折扣',
        };
    }
    curLevelChanged(val, oldVal) {
        if (val) {
            this.countdown();
        }
    }
    discountDataChanged(val, oldVal) {
        if (val) {
            this.activeItem = this.activeList[val];
            console.log('当前活动', this.discountData);
            this.countdown();
        }
    }
    get discountTypeName() {
        let limitBuyType = this.discountData.tag === '限时报名' ? '限时报名' : '限时折扣';
        let type = this.discountData.activity_type;
        return ((type === 'limit_buy' ? limitBuyType : this.typeMap[type]) || '限时折扣');
    }
    get priceObj() {
        let type = this.discountData.activity_type;
        let price = {};
        switch (type) {
            case 'limit_buy':
                price = {
                    discountPrice: this.discountData.sale_price,
                    basePrice: this.curLevel.originSalePrice || this.discountData.basePrice,
                };
                break;
            case 'group':
                price = {
                    discountPrice: Number(this.curLevel.originSalePrice - this.discountData.discount).toFixed(2),
                    // discountPrice: Number(this.curLevel.salePrice).toFixed(2),
                    basePrice: this.curLevel.originSalePrice || this.discountData.basePrice,
                };
                break;
            case 'presell':
                price = {
                    discountPrice: this.discountData.discount_price,
                    deposit: this.discountData.deposit,
                    basePrice: this.curLevel.originSalePrice || this.discountData.basePrice,
                };
                break;
            default:
                price = {
                    discountPrice: this.curLevel.salePrice,
                    basePrice: this.curLevel.originSalePrice || this.curLevel.originPrice,
                };
                break;
        }
        return price;
    }
    get limitTimeFilter() {
        return this.limitTime.splice(-3);
    }
    get getDay() {
        let day = this.limitTime[0];
        if (day === '00' || !day) {
            return '';
        }
        else {
            return Number(day) + '天';
        }
    }
    async mounted() {
        // 默认展示折扣价格
        //     @Prop() skuActivity: any[]
        // @Prop() spu: any
        // @Prop() skus: any[]
        // @Prop() curLevel: any
        // @Prop({ default: {} }) discountData: any
        this.countdown();
    }
    // 分销总体数据
    async setDefaultLimit() {
        let keys = Object.keys(this.skuActivity);
        if (keys.length === 0) {
            return;
        }
    }
    async countdown() {
        let endMap = {
            limit_buy: 'end_time',
            group: 'end_time',
            presell: 'presell_end_time',
            will_out: 'plan_unpublish_time',
            will_sale: 'planPublishTime',
        };
        let type = this.discountData.activity_type;
        let key = endMap[type];
        let end = this.discountData[key];
        if (!end) {
            end = this.curLevel[key];
            if (type === 'will_sale') {
                this.timeText = '距开售还剩:';
            }
            else if (type === 'will_out') {
                this.timeText = '距停售还剩:';
            }
        }
        // 没有结束时间
        if (!end)
            return;
        if (this.discountData.activity_type === 'limit_buy') {
            let start_time = +new Date(this.discountData.start_time.replace(/-/g, '/'));
            if (+new Date() < start_time) {
                end = this.discountData.start_time;
                this.timeText = '距秒杀开始还剩';
            }
            else {
                this.timeText = '距秒杀结束还剩';
            }
        }
        // 结束时间小于当前时间
        if (end && new Date(end.replace(/-/g, '/')).getTime() < Date.now()) {
            return;
        }
        const self = this;
        async function clock(end) {
            let msec = new Date(end.replace(/-/g, '/')).getTime() - new Date().getTime();
            // 倒计时没有了，刷新页面
            if (msec < 0) {
                if (self.timer) {
                    clearInterval(self.timer);
                }
                await utils.sleep(200);
                return self.$emit('update-page');
            }
            else {
                let remainTime = Date.formatMs(msec, 'DD hh mm ss');
                self.limitTime = remainTime.split(' ');
            }
        }
        if (this.timer) {
            clearInterval(this.timer);
        }
        clock(end);
        this.timer = setInterval(() => {
            clock(end);
        }, 1000);
    }
};
tslib_1.__decorate([
    Prop()
], DiscountSale.prototype, "skuActivity", void 0);
tslib_1.__decorate([
    Prop()
], DiscountSale.prototype, "spu", void 0);
tslib_1.__decorate([
    Prop()
], DiscountSale.prototype, "skus", void 0);
tslib_1.__decorate([
    Prop()
], DiscountSale.prototype, "curLevel", void 0);
tslib_1.__decorate([
    Prop({ default: {} })
], DiscountSale.prototype, "discountData", void 0);
tslib_1.__decorate([
    Prop()
], DiscountSale.prototype, "isApp", void 0);
tslib_1.__decorate([
    Prop()
], DiscountSale.prototype, "isVip", void 0);
tslib_1.__decorate([
    Watch('curLevel.id')
], DiscountSale.prototype, "curLevelChanged", null);
tslib_1.__decorate([
    Watch('discountData.activity_type')
], DiscountSale.prototype, "discountDataChanged", null);
DiscountSale = tslib_1.__decorate([
    Component({
        name: 'DiscountSale',
        filters: {
            filterInt: function (price = '') {
                return price.toString().split('.')[0];
            },
            filterFloat: function (price = '') {
                return price.toString().split('.')[1]
                    ? //  price
                        //     .toString()
                        //     .split('.')[1]
                        //     .substring(0, 2)
                        parseFloat(price)
                            .toString()
                            .split('.')[1]
                    : '00';
            },
        },
    })
], DiscountSale);
export default DiscountSale;
